import * as types from "@/store/mutation-types";
import { DefineMutations } from "vuex-type-helper";
import { SettingState, SettingMutations, StateKeys, ISetting } from "./types";
import {
  GenericDeleteItem,
  GenericSetEdit,
  GenericSetEditField,
  GenericSetItem,
  GenericSetState,
  GenericSetStates,
  GenericClearStore
} from "@/store/helpers";
import { getSettingsDefaults } from "@/helpers/defaultObjectGenerators";
import { defaultState } from "./state";

export const mutations: DefineMutations<SettingMutations, SettingState> = {
  [types.SET_STATE]: GenericSetState<SettingState, StateKeys>(),
  [types.SET_STATES]: GenericSetStates<SettingState>(),
  [types.SET_EDIT]: GenericSetEdit<SettingState, string | ISetting>(
    "settings",
    getSettingsDefaults
  ),
  [types.SET_EDIT_FIELD]: GenericSetEditField<SettingState, keyof ISetting>(),
  [types.SET_ITEM]: GenericSetItem<SettingState, ISetting>(
    "settings",
    getSettingsDefaults
  ), //TODO: WRITE A getXDefaultsFunction and pass it here in place of the anonymous function
  [types.DELETE_ITEM]: GenericDeleteItem<SettingState>("settings", "_id"),
  [types.CLEAR_SETTING_STORE]: GenericClearStore<SettingState>(defaultState())
};
